import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import useModalEffect from '../../../hooks/useModalEffect';

// Create/Edit Department — writes through to Datahub (Master Data), see
// hrisApi.js's createDepartment/updateDepartment.
const DepartmentFormModal = ({ isOpen, onClose, onSave, department, saving }) => {
  const [name, setName] = useState('');
  const [status, setStatus] = useState('1');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setError('');
      setName(department ? (department.departmentName || department.name || '') : '');
      setStatus(department && department.status !== 'Active' ? '0' : '1');
    }
  }, [isOpen, department]);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape' && isOpen) onClose(); };
    if (isOpen) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  useModalEffect(isOpen);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Department name wajib diisi.');
      return;
    }
    setError('');
    try {
      await onSave({ departmentName: name.trim(), status });
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Gagal menyimpan department.');
    }
  };

  return ReactDOM.createPortal(
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
      <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{department ? 'Edit Department' : 'Add Department'}</h5>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
              </div>
              <div className="modal-body">
                {error && <div className="alert alert-danger py-2">{error}</div>}
                <div className="mb-3">
                  <label className="form-label required">Department Name</label>
                  <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} required autoFocus />
                </div>
                <div className="mb-1">
                  <label className="form-label">Status</label>
                  <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-link link-secondary" onClick={onClose}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? 'Saving...' : department ? 'Save Changes' : 'Add Department'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default DepartmentFormModal;
